module.exports = __webpack_public_path__ + "jab/media/report-recycle.c4c21fba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/report-recycle.svg
// module id = 203
// module chunks = 0